export default {
  operationSuccess: lang.templateByUuid("UID:P_UDHWN_17DD50DE050005D6","操作成功") /* "操作成功" */,
  disConfirmIt2: lang.templateByUuid("UID:P_UDHWN_17DD50DE050005D7","停用") /* "停用" */,
  confirmIt2: lang.templateByUuid("UID:P_UDHWN_17DD50DE050005D8","启用") /* "启用" */,
  batchDeleteWarningOnly: lang.templateByUuid("UID:P_UDHWN_17DD50DE050005D9","只有一条规则不能删除！") /* "只有一条规则不能删除！" */,
  batchDeleteWarning: lang.templateByUuid("UID:P_UDHWN_17DD50DE050005DA","请选择至少一条状态为停用的规则") /* "请选择至少一条状态为停用的规则" */,
  handleBatchOperationWarning: lang.templateByUuid("UID:P_UDHWN_17DD50DE050005DB","请选择规则") /* "请选择规则" */
};
